'use strict';

import Component from '_core_ext/components/Component';
import eventMgr from '_core_ext/eventMgr';

const emitter = eventMgr.getEmitter('withdrawalrequest');

export default class ConfirmationWithdrawalRequest extends Component {
    init() {
        super.init();

        this.event('click touchstart', '.js-confirm-withdrawal', this.onConfirm);
        this.event('click touchstart', '.js-cancel', this.onCancel);
    }

    onConfirm(el, event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        const orderId = $(el).data('orderid');

        $.ajax({
            url: Urls.submitWithdrawalRequest,
            type: 'POST',
            data: {
                orderNo: orderId
            }
        }).done(function (data) {
            if (typeof data === 'string') {
                $document.find('.js-withdrawal-request-wrapper').replaceWith($(data));
            } else {
                $document.find('.js-order-cancel-error').removeClass('h-hidden');
            }
        }).always(() => {
            emitter.emit('closedialog');
        });
    }

    onCancel(el, event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        emitter.emit('closedialog');
    }
}
